import React from "react";
import { Link } from "react-router-dom";

export default function AdminFooter(){
    return(
        <footer className="py-4">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-sm-6">
                        <div className="text-sm-start text-center">
                            <p className="mb-0">{new Date().getFullYear()} © HRL. Desenhado e Desenvolvido <i className="mdi mdi-heart text-danger"></i> Por <Link to="#" target="_blank" className="text-reset">DJL</Link>.</p>
                        </div>
                    </div>

                    <div className="col-sm-6 mt-4 mt-sm-0">
                        <ul className="list-unstyled footer-list text-sm-end text-center mb-0">
                            <li className="list-inline-item"><Link to="#" className="text-foot me-2">Termos</Link></li>
                            <li className="list-inline-item"><Link to="#" className="text-foot me-2">Privacidade</Link></li>
                            <li className="list-inline-item"><Link to="/aboutus" className="text-foot me-2">Sobre Nós</Link></li>
                            <li className="list-inline-item"><Link to="/contact" className="text-foot me-2">Contacto</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    )
}